<template>
  <el-dialog v-dialogDrag title="复制表单" :visible.sync="dlgVisible" width="500px" :modal="false">
    <el-form :model="formInfo" label-width="100px" label-position="top" :rules="rules" size="small">
      <el-form-item label="新表单名称" prop="formName" size="small">
        <el-input v-model="formInfo.formName" clearable maxlength="30"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="新表单编号" prop="formCode">
        <el-input v-model="formInfo.formCode" clearable maxlength="30"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="remark">
        <el-input v-model="formInfo.remark" clearable maxlength="100" type="textarea" rows="3"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="default" size="small" @click="dlgVisible = false">取消</el-button>
      <el-button type="primary" size="small" @click="handleOk">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import metadataService from '@/CommonDP/service/metadata-service';

export default {
  data() {
    return {
      dlgVisible: false,
      formInfo: {
        sourceFormId: "",
        formName: "",
        formCode: "",
        remark: ""
      },
      rules: {
        formName: [{ required: true, message: ' ', trigger: 'blur' }],
        formCode: [{ required: true, message: ' ', trigger: 'blur' }]
      }
    };
  },

  methods: {
    show(oldFormInfo) {
      this.formInfo.sourceFormId = oldFormInfo.formId;
      this.formInfo.formName = oldFormInfo.formName;
      this.formInfo.formCode = oldFormInfo.formCode;
      this.formInfo.remark = oldFormInfo.remark;
      this.dlgVisible = true;
    },

    async handleOk() {
      try {
        await this.$confirm("确认复制吗？");
      } catch (e) {
        return;
      }
      await metadataService.cloneForm(this.formInfo);
      this.$success("复制成功");
      this.$emit("update");
      this.dlgVisible = false;
    }
  }
};
</script>
